const NUMBER_HAS_JONGSEONG = {
    '0': true,
    '1': true,
    '2': false,
    '3': true,
    '4': false,
    '5': false,
    '6': true,
    '7': true,
    '8': true,
    '9': false,
};
export function hasJongseong(word) {
    const last = word.trim().slice(-1);
    if (!last)
        return false;
    const numberResult = NUMBER_HAS_JONGSEONG[last];
    if (numberResult !== undefined)
        return numberResult;
    const code = last.charCodeAt(0);
    if (code >= 0xac00 && code <= 0xd7a3) {
        return (code - 0xac00) % 28 !== 0;
    }
    return false;
}
export function josa(word, pair) {
    const has = hasJongseong(word);
    switch (pair) {
        case '이/가':
            return has ? '이' : '가';
        case '은/는':
            return has ? '은' : '는';
        case '을/를':
            return has ? '을' : '를';
    }
}
//# sourceMappingURL=josa.js.map